//link and components
import React from "react"
import { Link } from "gatsby"
//style
import "../Styles/footer.scss"
import "bootstrap/dist/css/bootstrap.min.css"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
//imgs
import logoandtxt from "../images/logoandtxt.png"
import { Row, Col } from "react-bootstrap"
const BlogFooter = () => {
  return (
    <div className="footer-all-primary">
      <div className="footer-all">
        {/* footer one  logo on footer */}
        <Row className="footer-one">
          <Col md="5">
            {/* Socials icon on footer */}
            <ul className="logo-social-footer">
              <p>HINOTE ON SOCIAL MEDIA: </p>
            
              <div className="social-footer">
                <li>
                  <span className="badge social-footer-each ">
                    <FontAwesomeIcon
                      icon={["fab", "telegram"]}
                      className="fa-2x social-icon"
                    />
                  </span>
                </li>
                <li>
                  <span className="badge">
                    <FontAwesomeIcon
                      icon={["fab", "youtube"]}
                      className="fa-2x social-icon"
                    />
                  </span>
                </li>
                <li>
                  <span className="badge">
                    <FontAwesomeIcon
                      icon={["fab", "twitter"]}
                      className="fa-2x social-icon"
                    />
                  </span>
                </li>
                <li>
                  <span className="badge">
                    <FontAwesomeIcon
                      icon={["fab", "instagram"]}
                      className="fa-2x social-icon"
                    />
                  </span>
                </li>
              </div>
            </ul>
          </Col>

          {/* Hinote logo on footer */}
          <Col md="2">
            <div className="logo-txt">
              <img src={logoandtxt} width="120" alt="hinote logo" />
            </div>
          </Col>

          {/* pages shortcuts on footer */}
          <Col md="5">
            <Row>
              <Col xs={4} sm={4} md={5} lg={4}>
                <ul className="footer-cuts">
                  <li>
                    <Link to="/" className="footer-cut-link">
                      NEW MUSICS
                    </Link>
                    
                  </li>
                  <li>
                    <Link to="/" className="footer-cut-link">
                      MUSIC VIDEOS
                    </Link>
                    
                  </li>
                  <li>
                    <Link to="/" className="footer-cut-link">
                      SUGGESION
                    </Link>
                    
                  </li>
                </ul>
              </Col>
              <Col xs={4} sm={4} md={3} lg={4}>
                <ul className="footer-cuts">
                  <li>
                    <Link to="/" className="footer-cut-link">
                      NEWS
                    </Link>
                    
                  </li>
                  <li>
                    <Link to="/" className="footer-cut-link">
                      ARTICLE
                    </Link>
                    
                  </li>
                  <li>
                    <Link to="/" className="footer-cut-link">
                      CONCERT
                    </Link>
                    
                  </li>
                </ul>
              </Col>
              <Col xs={4} sm={4} md={4} lg={4}>
                <ul className="footer-cuts">
                  <li>
                    <Link to="/" className="footer-cut-link">
                     HOME
                    </Link>
                    
                  </li>
                  <li>
                    <Link to="/" className="footer-cut-link">
                     ABOUT US
                    </Link>
                    
                  </li>
                  <li>
                    <Link to="/" className="footer-cut-link">
                      CONTACT
                    </Link>
                    
                  </li>
                </ul>
              </Col>
            </Row>
          </Col>
        </Row>

        {/* copy right on footer */}
        <div className="footer-secondary">
          <p>
            &copy; Copyright &copy; 2020 All rights reserved by&nbsp;
            <Link to="/" className="hinote">
              Hinote
            </Link>
             &nbsp;| made by <Link to="www.gatsp.com" className="gatsp">
              gatsp&trade;
            </Link>
          </p>
        </div>
      </div>
    </div>
  )
}

export default BlogFooter
